import Vue from 'vue';
import ScreenOrientation from '@tencent/vft-ui/src/ScreenOrientation';
import reportPlugin from '@tencent/vft-report';
import login from '@tencent/vft-common/login';
import cookie from '@tencent/vft-common/cookie';
import { lockScroll } from '@vip-activity/vue-lib/directives';
import dialogPlugin from '@tencent/vft-vue-plugins/src/dialog';
import { vipService } from '@vip-activity/business';
import env from '@tencent/vft-common/env';
import atom from '@tencent/vft-atom';
import config from '../config';
import reportData from '../config/report';
Vue.prototype.reportData = reportData;
Vue.use(dialogPlugin);
Vue.use(ScreenOrientation);
Vue.directive('lockScroll', lockScroll);
var deviceInfo = null;

if (env.isApp) {
  try {
    atom.getDeviceInfo().then(function (res) {
      deviceInfo = res;
    });
  } catch (e) {
    console.error(e);
  }
}

Vue.use(reportPlugin, {
  config: {
    pv: {
      bossId: 5380,
      pwd: 895678138
    },
    event: {
      bossId: 5380,
      pwd: 895678138
    }
  },
  observerOptions: {
    root: document.getElementById('#app')
  },
  extraParams: function extraParams() {
    var _deviceInfo, _deviceInfo2;

    var loginType = login.loginType();
    return {
      f_logintype: loginType,

      /** 登录用户的vuid，用于精细化 */
      f_vuid: config.vuid,

      /** 获取登录账号 id */
      f_uid: login.getUid(),
      f_appid: loginType === 'wx' ? cookie.get('appid') : login.isNewQQLogin() ? cookie.get('vqq_appid') : '',
      f_vip: vipService.isInited ? vipService.isVip ? 1 : 0 : -1,
      f_level: vipService.level,
      f_version: 1,
      f_omgid: ((_deviceInfo = deviceInfo) === null || _deviceInfo === void 0 ? void 0 : _deviceInfo.omgid) || cookie.get('omgid'),
      omgid: ((_deviceInfo2 = deviceInfo) === null || _deviceInfo2 === void 0 ? void 0 : _deviceInfo2.omgid) || cookie.get('omgid')
    };
  },

  /** 是否延迟上报，若延迟上报，需通过主动调用 this.$report.ready() 启动上报 */
  delay: true,

  /** 是否输出调试信息，true为不输出 */
  silent: true
});